import config from './_config';
import classroom_registration from './classroom_registration';
import flash from './flash';
import free_trial from './free_trial';
import login from './login';
import placement_tests from './placement_tests';
import recover_password from './recover_password';
import registration from './registration';
import reset_password from './reset_password';
import user_account from './user_account';

config(APP_HOST);
classroom_registration()
flash()
free_trial()
login()
placement_tests()
recover_password()
registration()
reset_password()
user_account()
